<base-index-page 
    [config]="baseIndexPageConfig"
    [service]="proposalsService"
    [idKey]="'proposalPaymentConditionTypeId'"
    [subSectionSettings]="'deleteSettingsPaymentTerms'"
/>